module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "find-pas"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model == 'first'),
      expression: "model=='first'"
    }]
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入正确的手机号码/邮箱"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jcshow),
      expression: "jcshow"
    }],
    staticClass: "jtocode"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    staticClass: "wrongs"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.sendMsg
    }
  }, [_vm._v("下一步")])]), _vm._v(" "), (_vm.model == 'second') ? _c('div', [_c('div', {
    staticClass: "top1"
  }), _vm._v(" "), _c('p', {
    staticClass: "tel-msg"
  }, [_vm._v("验证码已发送至您的手机：" + _vm._s(_vm.phone.substr(0, 3) + '****' + _vm.phone.substr(7, 4)))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入收到的验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    staticClass: "wrongs"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.subcode
    }
  }, [_vm._v("提交验证码")]), _vm._v(" "), _c('p', {
    staticClass: "end-msg"
  }, [_vm._v("未收到验证码？请"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.sendNum))]), _vm._v("s后 "), _c('span', {
    staticClass: "blue",
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("重新发送")]), _vm._v(" 验证码或尝试 "), _c('span', {
    staticClass: "blue",
    on: {
      "click": _vm.resendno
    }
  }, [_vm._v("重新输入")]), _vm._v(" 手机号码")])]) : _vm._e(), _vm._v(" "), (_vm.model == 'third') ? _c('div', [_c('div', {
    staticClass: "top1"
  }), _vm._v(" "), _c('div', {
    staticClass: "email-suc"
  }, [_c('p', {
    staticClass: "end-msg center"
  }, [_vm._v("确认邮件已发送至您的邮箱：" + _vm._s(_vm.phone))]), _vm._v(" "), _c('p', {
    staticClass: "end-msg center"
  }, [_vm._v("未收到验证码？请"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.sendNum))]), _vm._v("s后 "), _c('span', {
    staticClass: "blue",
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("重新发送")]), _vm._v(" 验证码或尝试 "), _c('span', {
    staticClass: "blue",
    on: {
      "click": _vm.resendno
    }
  }, [_vm._v("重新输入")]), _vm._v(" 邮箱")])])]) : _vm._e(), _vm._v(" "), (_vm.model == 'four') ? _c('div', [_c('div', {
    staticClass: "top2"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repass),
      expression: "repass"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请再次输入新密码"
    },
    domProps: {
      "value": (_vm.repass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    staticClass: "wrongs"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.sure
    }
  }, [_vm._v("确定")])]) : _vm._e(), _vm._v(" "), _c('successalert', {
    attrs: {
      "show": _vm.show,
      "msg": _vm.msg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13cef8c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/findPas/findPas.vue
// module id = 103
// module chunks = 1